import { useTranslation } from "react-i18next";
import { findProductById } from "../../services/productService";

export const GoToPass = ({
  parentId,
  productId,
}: {
  parentId?: number;
  productId?: number;
}) => {
  const { t } = useTranslation();
  if (!parentId) return null;
  return (
    <button
      type="button"
      onClick={() => {
        findProductById(parentId.toString()).then((product) => {
          window.open(
            `/pass/${product.slug}?selectedProductIds=${productId}`,
            "_blank",
          );
        });
      }}
      className="mt-6 flex h-[46px] w-full items-center justify-center rounded-[12px] border-[1px] border-solid border-[#DEDEDE] bg-[#F7F8FA] px-[16px] text-[#5E6D77]"
    >
      <span
        dangerouslySetInnerHTML={{
          __html: t("go-to-pass-btn"),
        }}
      />
    </button>
  );
};
